var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.component,
    _vm._b({ tag: "component" }, "component", _vm.$attrs, false),
    [
      _vm._v(
        " " +
          _vm._s(_vm.formattedAmount) +
          " " +
          _vm._s(
            !_vm.hideUnit
              ? _vm.$t(`currency.${_vm.$config.currency.display}`)
              : ""
          ) +
          " "
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }